<template>
  <div class="join">
  	
  	<div class="login">
  	Game
  		<div class="loginline"><input v-model="$parent.gameId"></div>
  		Your name
  		<div class="validate" v-if="showvalidate">Please put a name here. Can be anything you like</div>
  		<div class="loginline"><input v-model="$parent.userId"></div>
  		Colour
  		<div class="loginline" style="text-align: center">
  			<div style="display: inline-block"><compact-picker v-model="$parent.colour" /></div>
  		</div>
  	
  	</div>
  	<br/>
  	<button v-on:click="checkJoin">Join</button>
  </div>
</template>

<script>
import { Compact } from 'vue-color'
export default {
  name: 'Join',
  props: {
  	
  },
  components: {
  	'compact-picker': Compact	
  },
  data:  function () {
    return {
    	showvalidate : false      
    }
  },
  methods: {
    checkJoin:function(event)
  	{	
  		if (this.$parent.userId=='') 
  		{
  			this.showvalidate = true
  		}
  		else {
  			this.$emit('login')
  		}
  	}
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.join {font-size:xx-large; }
	.login {padding-top:20px; border: 2px solid black;width: fit-content;display: inline-block}
	.loginline {margin:20px;}	
	.loginline input {font-size:xx-large; border:none; background-color:#eee; text-align: center;}
	button {font-size:xx-large;padding:20px; margin-top:40px;}
	.validate {font-size:small; color:red}
	
</style>